<template>
  <div>

    <table border="1" class="tableAB" v-if="renderType=='OTTOMAN-1000'">
      <thead class="theadAB">
        <tr>
          <th>p1(空杯)</th>
          <th>p2(加R1)</th>
          <th>p3(加样品搅拌)</th>
          <th>p4</th>
          <th>p5</th>
          <th>p6(加R2搅拌)</th>
          <th>p7</th>
          <th>p8</th>
          <th :colspan="last.colspan">{{last.text}}</th>
          
        </tr>
       
      </thead>
      <tbody class="tbodyAB">
        <tr>
          <td v-for="(item,index) in pList" :key="index"> {{item}}</td>
        </tr>
      </tbody>
    </table>

    <table border="1" class="tableAB" v-if="type=='ottoman2020_A'">
      <thead class="theadAB">
        <tr>
          <th>p1(水空白)</th>
          <th>p2(杯空白)</th>
          <th>p3(加R3)</th>
          <th>p4(加样本)</th>
          <th>p5(搅拌)</th>
          <th colspan='3'>
            p6-P8
          </th>
          <th>p9(加R1)</th>
          <th>p10(未搅拌)</th>
          <th>p11(搅拌)</th>
          <th colspan='5'>p12-p16</th>
          <th>p17(加R2)</th>
          <th>p18(搅拌)</th>
          <th :colspan="last.colspan">{{last.text}}</th>
        </tr>
      </thead>
      <tbody class="tbodyAB">
        <tr>
          <td v-for="(item,index) in pList" :key="index"> {{item}}</td>
        </tr>
      </tbody>
    </table>

    <table border="1" class="tableAB" v-if="type=='ottoman2020_O'">
      <thead class="theadAB">
        <tr>
          <th>p1(水空白吸光度)</th>
          <th>p2(杯空白吸光度)</th>
          <th>p3(加R1)</th>
          <th>p4(加样本)</th>
          <th>p5(搅拌)</th>
          <th colspan='5'>
            p6-P10
          </th>
          <th>p11(加R2搅拌)</th>
          <th :colspan="last.colspan">{{last.text}}</th>
        </tr>
       
      </thead>
      <tbody class="tbodyAB">
        <tr>
          <td v-for="(item,index) in pList" :key="index"> {{item}}</td>
       
        </tr>
      </tbody>
    </table>
<!--    OTM 6000 X-->
    <div class="otmWrap" v-if="renderType=='OTM 6000 X'">
      <table border="1" class="tableAB tableAB-otm">
        <thead class="theadAB">
          <tr>
            <th v-for="(g,gIndex) in otmHeaders" :key="'otm-th-'+gIndex" :colspan="g.colspan">{{g.label}}</th>
          </tr>
        </thead>
        <tbody class="tbodyAB">
          <tr>
            <template v-for="(g,gIndex) in otmHeaders">
              <td v-for="cIndex in g.colspan" :key="'otm-td-'+gIndex+'-'+cIndex">{{otmCell(g.from + cIndex - 1)}}</td>
            </template>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { matchOtmAbsMode, hasRequiredOtmAbsFields } from '@/utils/otmAbsorbance.js'
export default {
  props: ['value','type','testingUnique','sampleTypeName','method','waveType'],
  data() {
    return {
      pList: [],
      last: {
        text: '',
        colspan: 1,
      },
      ottoman2020_O_last: {

      },
      ottoman2020_O_last: {

      },
    }
  },
  computed: {
    // 展示前置条件：检测项目 / 方法学 都必须有值，缺任一个都不渲染（样本类型不作为前置条件）
    otmFieldsReady() {
      return hasRequiredOtmAbsFields(this.testingUnique, this.method)
    },
    // OTM 6000 X 下命中「项目 + 方法学」后得到的表头版式：layoutA / layoutB / layoutC / layoutD，未命中为 ''
    otmMode() {
      if (this.type != 'OTM 6000 X') return ''
      if (!this.otmFieldsReady) return ''
      return this.matchOtmCondition()
    },
    // 是否命中 OTM 6000 X 的新表头规则
    otmMatched() {
      return !!this.otmMode
    },
    // 字段缺失或未命中条件时均返回空，表格整块不渲染（标题由 SamplechecksDetail 决定是否下发）
    renderType() {
      if (this.type == 'OTM 6000 X' && !this.otmMatched) {
        return ''
      }
      return this.type
    },
    // 原始数组（不做过滤，保证 p0 对应 index 0、p7 对应 index 7 ……）
    otmList() {
      let v = this.value
      if (!v) return []
      if (typeof v === 'string') {
        try { v = JSON.parse(v) } catch (e) { v = v.split(',') }
      }
      return Array.isArray(v) ? v : []
    },
    // 当前渲染的是主波长行还是副波长行（'main' / 'sub'），默认按主波长处理
    isMainWave() {
      return this.waveType != 'sub'
    },
    // 表头版式配置：prefix 决定前缀段；p9Split 决定 p9/p10 是否拆开；stirTo/r2From 决定后两段的分界
    otmLayoutConfig() {
      switch (this.otmMode) {
        case 'layoutB':
          // p0(水空白)起：水空白/杯空白/加R3后/加样品搅拌后/水空白/杯空白 ...
          return { prefix: 'B', p9Split: false, stirTo: 13, r2From: 14 }
        case 'layoutC':
          // mALB：主波长拆 p9/p10，副波长合并
          return { prefix: 'A', p9Split: this.isMainWave, stirTo: 13, r2From: 14 }
        case 'layoutD':
          // NAG：加样品搅拌后延伸到 p20，加R2从 p21 起；主波长拆 p9/p10，副波长合并
          return { prefix: 'A', p9Split: this.isMainWave, stirTo: 20, r2From: 21 }
        case 'layoutA':
        default:
          return { prefix: 'A', p9Split: false, stirTo: 13, r2From: 14 }
      }
    },
    // 表头分组：取值一律按下标 p(n) -> index n
    otmHeaders() {
      const n = this.otmList.length
      if (!n) return []
      return this.buildOtmHeaders(n - 1)
    },
  },
  methods: {
    // 命中条件返回表头版式，未命中返回 ''（规则统一维护在 utils/otmAbsorbance.js）
    matchOtmCondition() {
      return matchOtmAbsMode(this.testingUnique, this.method)
    },
    // 生成一个表头分组：单点 p9(说明) 或区间 p9-p10(说明)
    buildOtmGroup(from, to, text) {
      return {
        label: to > from ? `p${from}-p${to}(${text})` : `p${from}(${text})`,
        colspan: to - from + 1,
        from,
      }
    },
    // 按版式配置生成完整表头（自动按数组实际长度收缩末段）
    buildOtmHeaders(end) {
      const cfg = this.otmLayoutConfig
      const groups = []
      if (cfg.prefix == 'B') {
        // p0(水空白) | p1(杯空白) | p2-p3(加R3后) | p4-p6(加样品搅拌后) | p7(水空白) | p8(杯空白) ...
        groups.push(this.buildOtmGroup(0, 0, '水空白'))
        if (end >= 1) groups.push(this.buildOtmGroup(1, 1, '杯空白'))
        if (end >= 2) groups.push(this.buildOtmGroup(2, Math.min(3, end), '加R3后'))
        if (end >= 4) groups.push(this.buildOtmGroup(4, Math.min(6, end), '加样品搅拌后'))
        if (end >= 7) groups.push(this.buildOtmGroup(7, 7, '水空白'))
        if (end >= 8) groups.push(this.buildOtmGroup(8, 8, '杯空白'))
      } else {
        // p0-p6(无意义) | p7(水空白) | p8(杯空白) ...
        const g0To = Math.min(6, end)
        groups.push({
          label: g0To > 0 ? `p0-p${g0To}(无意义)` : 'p0(无意义)',
          colspan: g0To + 1,
          from: 0,
        })
        if (end >= 7) groups.push(this.buildOtmGroup(7, 7, '水空白'))
        if (end >= 8) groups.push(this.buildOtmGroup(8, 8, '杯空白'))
      }
      // 加R1后：主波长（p9Split）把 p9、p10 拆成「加R1后 / 吐样且未搅拌」
      if (end >= 9) {
        if (cfg.p9Split) {
          groups.push(this.buildOtmGroup(9, 9, '加R1后'))
          if (end >= 10) groups.push(this.buildOtmGroup(10, 10, '吐样且未搅拌'))
        } else {
          groups.push(this.buildOtmGroup(9, Math.min(10, end), '加R1后'))
        }
      }
      if (end >= 11) groups.push(this.buildOtmGroup(11, Math.min(cfg.stirTo, end), '加样品搅拌后'))
      if (end >= cfg.r2From) groups.push(this.buildOtmGroup(cfg.r2From, end, '加R2搅拌后'))
      return groups
    },
    // 按 index 取值：p0 -> index 0 …… p7 -> index 7，以此类推
    otmCell(index) {
      console.log(index)
      const item = this.otmList[index]
      return item == null ? '-' : item
    },
  },
  created() {
    // this.pList = this.value
    if (Array.isArray(this.value)) {
      this.value.forEach(e=>{
        if(e!=null){
          this.pList.push(e)
        }
      })
    }
    switch (this.renderType) {
      case 'OTTOMAN-1000':
        this.last.colspan = this.pList.length-8
        this.last.text = this.last.colspan > 1?`p9-p${this.pList.length}`:'p9'
        break;
      case 'ottoman2020_O':
        this.last.colspan = this.pList.length-11
        this.last.text = this.last.colspan > 1?`p12-p${this.pList.length}`:'P12'
        break;
      case 'ottoman2020_A':
        this.last.colspan = this.pList.length-18
        this.last.text = this.last.colspan > 1?`p19-p${this.pList.length}`:'P19'
        break;
      default:
        break;
    }
    
  },
}
</script>

<style lang="scss" scoped>
.otmWrap{
  width:100%;
  overflow-x: auto;

  .tableAB-otm{
    width: max-content;
    min-width: 100%;
    th,td{
      white-space: nowrap;
      padding: 0 px(4);
    }
  }
}
.tableAB{
  width:100%;
  border-spacing: 0;
  border-collapse: collapse;
  .theadAB{
    tr {
      th {
        font-size: px(20);
        text-align: center;
      }
    }
   
  }
  .tbodyAB {
    tr {
      td {
        font-size: px(20);
        text-align: center;
      }
    }
  }
}
</style>>
